"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = filterChildren;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function filterChildren(children, props) {
  var newChildren = _index["default"].filter(children, function (child) {
    return child !== null;
  });

  if (props) {
    return _react["default"].Children.map(newChildren, function (child) {
      return /*#__PURE__*/_react["default"].cloneElement(child, props);
    });
  }

  if (newChildren.length === 1) {
    return newChildren[0];
  }

  return newChildren;
}